import { createApp } from 'vue'
import App from './App.vue'
import router from './router'


const app = createApp(App)

app.use(router)

app.mount('#app')


router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})